import { Controller } from 'stimulus'
import Cropper from 'cropperjs'

export default class extends Controller {
  static targets = ['canvas', 'cropperImage', 'cropperSelection', 'preview', 'productPreviewImage', "formImageData", "uploadBtn", "form"]

  connect() {
    console.log("targ", this.cropperImageTarget);

    const cropperCanvasRect = this.canvasTarget.getBoundingClientRect();

    this.cropperSelectionTarget.addEventListener("change", e => {
      const selection = event.detail;
      //console.log("change selection", e);
      const cropperImage = this.cropperImageTarget;
      const cropperImageRect = this.cropperImageTarget.getBoundingClientRect();
      const maxSelection = {
        x: cropperImageRect.left - cropperCanvasRect.left,
        y: cropperImageRect.top - cropperCanvasRect.top,
        width: cropperImageRect.width,
        height: cropperImageRect.height,
      };

      // if (!this.inSelection(selection, maxSelection)) {
      //   event.preventDefault();
      // }


      let selectionX = Math.trunc(Math.abs(selection.x - (cropperImageRect.left - cropperCanvasRect.left)));
      let selectionY = Math.abs(selection.y);
      
      console.log(`selection data: X${selection.x}, Y${selection.y} - W${selection.width}, H${selection.height}`)

      // document.getElementById("crop_settings").value = JSON.stringify({
      //   x: selection.x,
      //   y: selection.y,
      //   width: selection.width,
      //   height: selection.height,
      // });  
      

    })

    this.canvasTarget.addEventListener("action", e => {
      console.log("canvas action", e.detail.action)
    })

    this.cropperImageTarget.addEventListener("transform", function(e) {

    })

  }

    inSelection(selection, maxSelection) {
      return (
        selection.x >= maxSelection.x
        && selection.y >= maxSelection.y
        && (selection.x + selection.width) <= (maxSelection.x + maxSelection.width)
        && (selection.y + selection.height) <= (maxSelection.y + maxSelection.height)
      );
    }

    async saveCrop() {
      var canvas = await this.cropperSelectionTarget.$toCanvas();
      var img = canvas.toDataURL();
      this.productPreviewImageTarget.src = img;
      this.formImageDataTarget.value = this.productPreviewImageTarget.src;
    }

   
    
    rotateImageRight() {
      this.cropperImageTarget.$rotate('45deg');
    }
    
    rotateImageLeft() {
      this.cropperImageTarget.$rotate('-45deg');
    }

    toggleCoverImage() {
      this.cropperImageTarget.$center('cover')
      console.log(this.cropperImageTarget);
    }
    
    flipImageHorizontally() {
      this.cropperImageTarget.$scale(-1, 1);
    }

    flipImageVertically() {
      this.cropperImageTarget.$scale(1, -1);
    }

    centerImage() {
      this.cropperImageTarget.$center('contain');
    }
    
    async checkAttachedCroppedImageBeforeUpload(e) {
      e.preventDefault() 
      if (!this.productPreviewImageTarget.src.includes("base64")) {
        await this.saveCrop();
      } else {
        this.formImageDataTarget.value = this.productPreviewImageTarget.src;
      }
      this.formTarget.requestSubmit();
      
    }

    async setPreviewOptionCover(e) {
      await this.saveCrop()
      this.productPreviewImageTarget.classList.add("object-cover")
      this.productPreviewImageTarget.classList.remove("object-contain")
    }

    async setPreviewOptionContain(e) {
      await this.saveCrop()
      this.productPreviewImageTarget.classList.add("object-contain")
      this.productPreviewImageTarget.classList.remove("object-cover")
    }


}
